import api from "../api/api";
import { appState } from "../redux/redux-config";

const account = {
  getAccountDetails: async function () {
    let token = appState().user.token;
    let result = await api.account.getAccountDetails(token);
    if (result.success) {
      return result;
    }
  },
  updateAccountGeneral: async function (data, logoFile) {
    let token = appState().user.token;
    let result = await api.account.updateAccountGeneral(token, data, logoFile);
    if (result.success) {
      return result;
    }
  },
  getDisplaySettings: async function () {
    let token = appState().user.token;
    let result = await api.account.getDisplaySettings(token);
    if (result.success) {
      return result;
    }
  },
  connectTwitter: async function (redirectUri, scopes = "tweet.read users.read follows.read") {
    let token = appState().user.token;
    return await api.account.connectTwitter(token, { redirectUri, scopes });
  },
  twitterCallback: async function (code, state, expectedState, redirectUri, codeVerifier) {
    let customerId = appState().user.customerId;
    return await api.account.twitterCallback({ customerId, code, state, expectedState, redirectUri, codeVerifier });
  },
  getTwitterStatus: async function () {
    let token = appState().user.token;
    return await api.account.getTwitterStatus(token);
  },
  disconnectTwitter: async function (socialConnectionId) {
    let token = appState().user.token;
    return await api.account.disconnectTwitter(token, socialConnectionId);
  },
  connectLinkedIn: async function (redirectUri) {
    let token = appState().user.token;
    return await api.account.connectLinkedIn(token, { redirectUri });
  },
  linkedinCallback: async function (code, state, expectedState, redirectUri) {
    let customerId = appState().user.customerId;
    return await api.account.linkedinCallback({ customerId, code, state, expectedState, redirectUri });
  },
  getLinkedInStatus: async function () {
    let token = appState().user.token;
    return await api.account.getLinkedInStatus(token);
  },
  disconnectLinkedIn: async function (socialConnectionId) {
    let token = appState().user.token;
    return await api.account.disconnectLinkedIn(token, socialConnectionId);
  },
  getLinkedInCredentialsStatus: async function () {
    let token = appState().user.token;
    return await api.account.getLinkedInCredentialsStatus(token);
  },
  configureLinkedInCredentials: async function (clientId, clientSecret) {
    let token = appState().user.token;
    return await api.account.configureLinkedInCredentials(token, {
      clientId,
      clientSecret,
    });
  },
  saveDisplaySettings: async function (showFilterGroupDesc) {
    let token = appState().user.token;
    return await api.account.saveDisplaySettings(token, { showFilterGroupDesc });
  },
  updateAccountMessaging: async function (data) {
    let token = appState().user.token;
    let result = await api.account.updateAccountMessaging(token, data);
    if (result.success) {
      return result;
    }
  },
  updateAccountAlertCategories: async function (data) {
    let token = appState().user.token;
    let result = await api.account.updateAccountAlertCategories(token, data);
    if (result.success) {
      return result;
    }
  },
  getImportSettings: async function () {
    let token = appState().user.token;
    let result = await api.account.getImportSettings(token);
    if (result.success) return result;
  },
  saveImportSettings: async function (data) {
    let token = appState().user.token;
    return await api.account.saveImportSettings(token, data);
  },
  getDashboardAccess: async function () {
    let token = appState().user.token;
    let result = await api.account.getDashboardAccess(token);
    if (result.success) {
      return result;
    }
  },
  saveDashboardAccess: async function (studentViewOnly, facultyViewOnly) {
    let token = appState().user.token;
    return await api.account.saveDashboardAccess(token, { studentViewOnly, facultyViewOnly });
  },
  getPermissions: async function () {
    let token = appState().user.token;
    let result = await api.account.getPermissions(token);
    if (result.success) {
      return result;
    }
  },
  saveSecuritySettings: async function (passwordRecoveryEnabled) {
    let token = appState().user.token;
    return await api.account.saveSecuritySettings(token, { passwordRecoveryEnabled });
  },
  getLoginAccess: async function () {
    let token = appState().user.token;
    let result = await api.account.getLoginAccess(token);
    if (result.success) {
      return result;
    }
  },
  saveLoginAccess: async function (allowStudentLogin, allowFacultyLogin, emergencyOnly, optOutRecovery) {
    let token = appState().user.token;
    return await api.account.saveLoginAccess(token, {
      allowStudentLogin,
      allowFacultyLogin,
      emergencyOnly,
      optOutRecovery,
    });
  },
};

export default account;
